export default __webpack_public_path__ + "static/media/M1-male-01_mos_MPOL.a527e107.wav";